// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"38":"c37df394","91":"62f7b1e7","361":"1026012a","485":"14c9ef75","492":"3bf6f78a","585":"4bfbaf83","703":"c4c23680","750":"bcd7ae48","875":"547d51ac","877":"586e21c6","989":"848e273e"}[chunkId] + ".js";
};